import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  whyWorldeskState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const whyWorldeskSlice = createSlice({
  name: 'whyWorldesk',
  initialState: initialState,
  reducers: {
    getWhyWorldeskRequest: (state: any) => {
      state.whyWorldeskState.isFetching = true
      state.whyWorldeskState.isFetched = false
      state.whyWorldeskState.isFailed = false
      state.whyWorldeskState.errorMessage = ''
    },
    getWhyWorldeskSuccess: (state: any, action) => {
      state.whyWorldeskState.isFetching = false
      state.whyWorldeskState.isFetched = true
      state.whyWorldeskState.item = action.payload.item
    },
    getWhyWorldeskFailure: (state: any, action) => {
      state.whyWorldeskState.isFetching = false
      state.whyWorldeskState.isFetched = true
      state.whyWorldeskState.isFailed = true
      state.whyWorldeskState.errorMessage = action.payload.errorMessage
    },
  },
})

export const {
  getWhyWorldeskRequest,
  getWhyWorldeskSuccess,
  getWhyWorldeskFailure,
} = whyWorldeskSlice.actions

export default whyWorldeskSlice.reducer
